/** @import { FC } from 'react' */
import { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getUser, getUserSchema, updateUser } from '@plone/volto/actions';
import { toast } from 'react-toastify';
import { Form, Toast } from '@plone/volto/components';

// Where saving and cancelling lead when there is no page of the intranet to
// go back to
const FALLBACK_PATH = '/controlpanel/users';

const EditUserView = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const [loading, setLoading] = useState(false);
  const { userId } = useParams();

  const userschema = useSelector((state) => state.userschema || {});
  const user = useSelector((state) => state.users?.user || {});

  // A location without key was not pushed by the app but opened directly,
  // from a bookmark, a link or in a new tab; going back would leave the
  // intranet (#22806)
  const leave = () => {
    if (history.location?.key) {
      history.goBack();
    } else {
      history.replace(FALLBACK_PATH);
    }
  };

  const onSubmit = (data) => {
    // We don't want the user to change his login name/username or the roles
    // from this form
    // Backend will complain anyways, but we clean the data here before it does
    delete data.id;
    delete data.username;
    delete data.roles;
    setLoading(true);
    dispatch(updateUser(userId, data)).then(
      () => {
        toast.success(
          <Toast
            success
            title={'Erfolgreich'}
            content={'Benutzerdaten gespeichert'}
          />,
        );
        leave();
      },
      () => {
        setLoading(false);
        toast.error(
          <Toast
            error
            title={'Fehler'}
            content={'Benutzerdaten konnten nicht gespeichert werden'}
          />,
        );
      },
    );
  };

  const onCancel = () => {
    leave();
  };

  useEffect(() => {
    dispatch(getUser(userId));
    dispatch(getUserSchema());
  }, [dispatch, userId]);

  return (
    userschema?.loaded &&
    user?.id === userId && (
      <Form
        formData={user}
        schema={userschema.userschema}
        onSubmit={onSubmit}
        onCancel={onCancel}
        loading={loading}
      />
    )
  );
};

export default EditUserView;
